<div class="success-modal">
  <div class="title">
    Thank you for upgrading to <span class="plan">{{ paymentPlan }}</span
    >!
  </div>
  <div class="description">
    <p>
      Your subscription has been successfully updated, unlocking exclusive
      features and enhanced benefits just for you.
    </p>
    <p *ngIf="isCompletePlan">
      You will receive a separate email from us on a membership card and guide
      to access our provider network within 24 hours.
    </p>
  </div>

  <div>
    <button
      (click)="goToDashboard()"
      mat-button
      class="action-button button-primary"
    >
      OK
    </button>
  </div>
</div>
